// extracted by mini-css-extract-plugin
export var footer = "_kk-0";
export var inherit = "_kk-1";
export var input = "_kk-2";
export var modalContent = "_kk-3";
export var quillEditor = "_kk-4";
export var subtitle = "_kk-5";